export const API_KEY_GET_NOTIFICATION_STYLES_OPTIONS =
  "API_KEY_GET_NOTIFICATION_STYLES_OPTIONS";
